import { api } from "api/apiService";

/**
 * Завантажує дані про зв'язки та статуси між магазинами та постачальниками.
 * @returns {Promise<Array>} Проміс, що повертає масив зі статусами.
 */
export const fetchShopsBySuppliers = () => {
  return api.get("/shopsStatus");
};

/**
 * Виконує пакетне оновлення статусів постачальників для конкретного магазину.
 * @param {number|string} shops_id - ID магазину, для якого оновлюються статуси.
 * @param {Array<object>} updates - Масив об'єктів, де кожен об'єкт містить { suppliers_id, status }.
 * @returns {Promise<object>} Проміс, що повертає відповідь від сервера.
 */
export const updateShopStatuses = (shops_id, updates) => {
  return api.put(`/shopsStatus/${shops_id}/statuses`, { updates });
};
